// extracted by mini-css-extract-plugin
module.exports = {"contMenuGifts":"styles_contMenuGifts__2n_UW","contButtons":"styles_contButtons__2CTGw"};